import { IUpdateSenderProfileRequest } from "shared";

import { TextEditor, wrapBlockImages } from "../../../../Molecules/TextEditor/TextEditor";
import { useGeneralSettingsForm } from "../../../../../hooks/useGeneralSettingsForm";
import { FormLabel } from "../../../../../../common/Atoms/FormLabel";
import { FormDescription } from "../../../../../../common/Atoms/FormDescription";

interface EmailSignatureProps {
  profile: IUpdateSenderProfileRequest;
}

export function EmailSignature({
  profile,
}: EmailSignatureProps) {
  const { formData, onChange } = useGeneralSettingsForm();

  function handleChange({ html, json }) {
    const newProfile = {
      ...profile,
      signatureHtml: html,
      signatureJson: JSON.stringify(json),
    };

    const newProfiles = formData.senderProfiles?.map(p => {
      if (p.id === profile.id) {
        return newProfile;
      }

      return p;
    }) || [];

    onChange(`senderProfiles`, newProfiles);
  }

  return (
    <div className={ `max-w-[600px]` }>
      <FormLabel>
        { `Email Signature` }
      </FormLabel>
      <FormDescription>
        { `Your email signature will be appended to the bottom of all emails sent from this profile.` }
      </FormDescription>
      <TextEditor
        mergeTags={ [] }
        onChange={ handleChange }
        htmlValue={ profile.signatureHtml || `` }
        value={ profile.signatureJson ? wrapBlockImages(JSON.parse(profile.signatureJson)) : {} }
        mode={ `signature` }
      />
    </div>
  );
}
